import Modal from '../common/Modal'

interface ModalAudioPermissionProps {
  isOpen: boolean
}

const ModalAudioPermission = ({ isOpen }: ModalAudioPermissionProps) => {
  return (
    <Modal isOpen={isOpen} closeModal={() => {}} showCloseButton={false}>
      <div className="mb-2 text-2xl font-bold text-jba-blue">Izin Mikrofon Diperlukan</div>
      <div className="mb-4 text-xs text-gray-500">
        Untuk melakukan panggilan, kami membutuhkan izin untuk mengakses mikrofon Anda. Silakan klik tombol izinkan
        mikrofon
      </div>
    </Modal>
  )
}

export default ModalAudioPermission
